import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function ProfessionalList({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item label="ID da Especialidade" name={[fieldName, 'action', 'data', 'especialidade_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="ID da Unidade" name={[fieldName, 'action', 'data', 'unidade_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
